'use client';

import React, { createContext, useContext, ReactNode } from 'react';
import { emptyFlags } from '@provider-directory/services/posthog-shared';
import type { FlagContextType } from '@provider-directory/types/flags';

export const FlagContext = createContext<FlagContextType>(emptyFlags);

export const useFeatureFlags = (): FlagContextType => useContext(FlagContext);

interface FlagProviderProps {
  children: ReactNode;
  flags: FlagContextType;
}

export const FlagProvider: React.FC<FlagProviderProps> = ({
  children,
  flags,
}): ReactNode => {
  return <FlagContext.Provider value={flags}>{children}</FlagContext.Provider>;
};
